import { createStore } from 'vuex'

import {all_words_tsv} from "@/js/words_list";
import {shuffle} from "@/js/helpers";
import {loadLang, saveLang} from "@/js/lang";

const localStorageKey = 'alias2_cards_v4';
const localStorageIndexKey = 'alias2_index';
const initCardsList = (rows) => {
    const stored = localStorage.getItem(localStorageKey);
    if (stored && stored.length > 0) {
        return JSON.parse(stored);
    }
    let result = shuffle([...rows]);
    localStorage.setItem(localStorageKey, JSON.stringify(result));
    return result;
}

export const store = createStore({
    strict: true,
    state () {
        return {
            rows: initCardsList(all_words_tsv.split('\n')),
            index: JSON.parse(localStorage.getItem(localStorageIndexKey)) || 0,
            lang: loadLang()
        }
    },
    getters: {
        currentWord (state) {
            const parts = state.rows[state.index].split('\t'); // 0 = eng, 1 = rus, 2 = picture
            return state.lang === 'en' ? parts[0] : parts[1];
        },
        currentImgSrc (state) {
            console.log("index = ", state.index, ", rows[index] = ", state.rows[state.index]);
            return `img/words-images/${state.rows[state.index].split('\t')[2]}`
        },
        nextImgSrc (state) {
            return `img/words-images/${state.rows[state.index+1].split('\t')[2]}`
        }
    },
    mutations: {
        advanceIndex (state) {
            state.index++;
            if (state.index >= state.rows.length) {
                console.log(`Index reached ${state.index}, shuffling`);
                shuffle(state.rows);
                localStorage.setItem(localStorageKey, JSON.stringify(state.rows));
                state.index = 0;
            }
            localStorage.setItem(localStorageIndexKey, JSON.stringify(state.index));
        },
        prevIndex (state) {
            if (state.index <= 0) {
                return
            }
            state.index--;
            localStorage.setItem(localStorageIndexKey, JSON.stringify(state.index));
        },
        toggleLang (state) {
            state.lang = state.lang === 'en' ? 'ru' : 'en';
            saveLang(state.lang);
        }
    },
    actions: {
    }
})